import Vue from 'vue'
import VueI18n from 'vue-i18n'
import dateTimeFormats from '@/services/api/datetime'

import en from './phrases/en.json'
import es from './phrases/es.json'
import ru from './phrases/ru.json'

Vue.use(VueI18n)

export const defaultLocale = 'en'

export const getLocaleSettings = (locale = defaultLocale) => ({
  locale,
  fallbackLocale: defaultLocale,
  silentFallbackWarn: true,
  dateTimeFormats: dateTimeFormats,
  messages: { en, es, ru }
})

const i18n = new VueI18n(getLocaleSettings())

export default i18n
